import { Badge } from '@/components/ui/Badge'
import { STATUS_META } from '@/features/support/supportLabels'
import type { TicketStatus } from '@/types/support-ticket.types'

export function TicketStatusBadge({
  status,
  className,
}: {
  status: TicketStatus
  className?: string
}): React.ReactElement {
  const meta = STATUS_META[status] ?? STATUS_META.open
  return (
    <Badge variant={meta.variant} dot className={className}>
      {meta.label}
    </Badge>
  )
}

TicketStatusBadge.displayName = 'TicketStatusBadge'
